module.exports = __webpack_public_path__ + "static/img/img(39).3555f5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/training/img(39).png
// module id = NeNZ
// module chunks = 1